import styled from '@emotion/styled';
import { token, TextCaption } from '@ferreri/prever-component-lib';
import { ReactNode } from 'react';

type PlanItemProps = {
  label?: string;
  icon: ReactNode;
};

const PlanItem = (props: PlanItemProps) => {
  if (!props.label) return null;

  return (
    <ContainerPlanItem>
      {props.icon}
      <TextCaption>{props.label}</TextCaption>
    </ContainerPlanItem>
  );
};

export const ContainerPlanItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${token.spacing.spacingXxSmall};
  width: 100%;

  > svg {
    flex-shrink: 0;
  }
`;

export default PlanItem;
